/**
 * Centralized documentation links configuration
 */

import { branding } from './branding'

const DOCS_BASE_URL = branding.documentationUrl
const PLATFORM_GUIDE_BASE = `${DOCS_BASE_URL}/platform-guide`
const GETTING_STARTED_BASE = `${DOCS_BASE_URL}/getting-started`
const API_BASE = `${DOCS_BASE_URL}/api-reference`

export const DOCUMENTATION_LINKS = {
	platformGuide: {
		introduction: `${PLATFORM_GUIDE_BASE}/introduction`,
		deviceManagement: `${PLATFORM_GUIDE_BASE}/device-management/introduction-to-device-management`,
		dashboards: `${PLATFORM_GUIDE_BASE}/dashboards/introduction-to-dashboards`,
		dbcParsers: `${PLATFORM_GUIDE_BASE}/dbc-parsers/introduction-to-dbc-parsers`,
		sessionRules: `${PLATFORM_GUIDE_BASE}/alert-system/introduction-to-alerts-and-notifications`,
		actions: `${PLATFORM_GUIDE_BASE}/actions/action-details/live-actions-list`,
		inventory: `${PLATFORM_GUIDE_BASE}/actions/inventory-management/introduction`,
		exporters: `${PLATFORM_GUIDE_BASE}/exporters/introduction-to-exporters`,
		notifications: `${PLATFORM_GUIDE_BASE}/alert-system/introduction-to-alerts-and-notifications`,
		streams: `${PLATFORM_GUIDE_BASE}/streams-tables/introduction-to-streams`,
		roles: `${PLATFORM_GUIDE_BASE}/roles/role-based-access-control`,
		users: `${PLATFORM_GUIDE_BASE}/users/introduction-to-users-in-projects`,
		apiKeys: `${PLATFORM_GUIDE_BASE}/api-keys/introduction-to-api-keys`,
		metadata: `${PLATFORM_GUIDE_BASE}/metadata/introduction-to-metadata-keys`,
	},

	gettingStarted: {
		quickStart: `${GETTING_STARTED_BASE}/quick-start`,
		deviceSetup: `${GETTING_STARTED_BASE}/device-setup`,
		firstDashboard: `${GETTING_STARTED_BASE}/first-dashboard`,
	},

	api: {
		overview: `${API_BASE}/overview`,
		authentication: `${API_BASE}/authentication`,
		devices: `${API_BASE}/devices`,
		streams: `${API_BASE}/streams`,
	},
} as const

/**
 * Securely opens a documentation link in a new tab with noopener and noreferrer
 * @param url - The documentation URL to open
 */
export const openDocumentationLink = (url: string): void => {
	window.open(url, '_blank', 'noopener,noreferrer')
}
